// extracted by mini-css-extract-plugin
export default {"container":"q3-z","list":"r3-z"};